import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { Icon } from "@iconify/react/dist/iconify.js";
import { usePermissions } from "../context/PermissionContext";

const SubscriptionExpiredModal = ({ onClose }) => {
  const navigate = useNavigate();
  const {
    hasPermission,
  } = usePermissions();
  const handleLogout = () => {
    localStorage.clear();
    navigate("/sign-in");
    if (onClose) onClose();
  };
  return (
    <>
      <style>
        {`
         /* Subscription Expired Modal Styles */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.modal-content {
  background: var(--white);
  border-radius: var(--rounded-12);
  padding: var(--size-32);
  max-width: 32rem;
  width: 100%;
  text-align: center;
  box-shadow: var(--shadow-2);
  position: relative;
}

.modal-content h3 {
  font-size: var(--font-xl);
  font-weight: 600;
  color: var(--text-primary-light);
  margin-bottom: var(--size-16);
}

.modal-content p {
  font-size: var(--font-md);
  color: var(--text-secondary-light);
  margin-bottom: var(--size-24);
}

.modal-content .button-container {
            display: flex;
            justify-content: center;
            gap: var(--size-16);
          }

          .modal-content .renew-button,
          .modal-content .logout-button {
            display: inline-flex;
            align-items: center;
            justify-content: center;
            gap: var(--size-8);
            padding: var(--size-12) var(--size-24);
            border: none;
            border-radius: var(--rounded-8);
            font-size: var(--font-md);
            font-weight: 500;
            text-decoration: none;
            transition: background 0.3s ease;
          }

          .modal-content .renew-button {
            background: var(--primary-600);
            color: var(--white);
          }

          .modal-content .renew-button:hover {
            background: var(--primary-700);
          }

          .modal-content .logout-button {
            background: var(--danger-600);
            color: var(--white);
          }

          .modal-content .logout-button:hover {
            background: var(--danger-700);
          }

          .modal-content .close-button {
            position: absolute;
            top: var(--size-16);
            right: var(--size-16);
            background: none;
            border: none;
            font-size: var(--font-lg);
            color: var(--neutral-500);
            cursor: pointer;
          }

          .modal-content .close-button:hover {
            color: var(--primary-600);
          }

@media (max-width: 768px) {
  .modal-content {
    padding: var(--size-24);
    margin: var(--size-16);
  }
  .modal-content h3 {
    font-size: var(--font-lg);
  }
  .modal-content p {
    font-size: var(--font-sm);
  }
    .modal-content .button-container {
              flex-direction: column;
              gap: var(--size-12);
            }
}
        `}
      </style>
      <div className="modal-overlay">
        <div className="modal-content">
          {/* onClick={onClose} */}
          {/* <button className="close-button" onClick={handleLogout} title="Close">
            <Icon icon="radix-icons:cross-2" />
          </button> */}
          <h3>Subscription Expired</h3>
          <p>
            Your subscription has expired. Please renew to continue accessing
            all features.
          </p>
          <div className="button-container">
            {hasPermission("view_subscription") && (
            <Link to="/subscription" className="renew-button">
              <Icon icon="mdi:refresh" />
              Upgrade Plan
            </Link>)}
            <button
              type="button"
              className="logout-button"
              onClick={handleLogout}
            >
              <Icon icon="mdi:logout" />
              Logout
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default SubscriptionExpiredModal;
